/**
 * Carrito Oleum — recomendaciones híbridas + intersticial al checkout.
 */
(function () {
  'use strict';

  var LIMIT = 4;
  var REC_INTENT = 'complementary';
  var SECTION_ID = 'oleum-search-render-card';
  var refreshTimer = null;
  var cardCache = Object.create(null);
  var stateByRoot = new WeakMap();
  var upsellBusy = false;
  var allowCheckoutSubmit = false;

  function roots() {
    return document.querySelectorAll('[data-oleum-cart-rec]');
  }

  function upsellDialog() {
    return document.querySelector('[data-oleum-cart-upsell]');
  }

  function upsellRecRoot() {
    var dialog = upsellDialog();
    return dialog ? dialog.querySelector('[data-oleum-cart-rec]') : null;
  }

  function shopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function checkoutUrl() {
    var dialog = upsellDialog();
    var fromLiquid = dialog && dialog.getAttribute('data-checkout-url');
    if (fromLiquid) return fromLiquid;

    var root = shopifyRoot();
    if (!root || root === '/') return window.location.origin + '/checkout';
    var path = (root.charAt(0) === '/' ? root : '/' + root).replace(/\/$/, '') + '/checkout';
    return window.location.origin + path.replace(/([^:]\/)\/+/g, '$1');
  }

  function findCartForm() {
    return document.querySelector(
      'cart-drawer-component form#cart-form, .oleum-cart-page form#cart-form, form#cart-form[action*="cart"]'
    );
  }

  function submitCartCheckout() {
    var form = findCartForm();
    var btn = form && form.querySelector('button[name="checkout"], input[name="checkout"]');

    if (form && btn) {
      allowCheckoutSubmit = true;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(btn);
      } else {
        btn.click();
      }
      return true;
    }

    window.location.href = checkoutUrl();
    return false;
  }

  function cartFingerprint(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';
    return cart.items
      .map(function (item) {
        return String(item.product_id) + ':' + String(item.quantity);
      })
      .sort()
      .join('|');
  }

  function picksFingerprint(picks) {
    return picks
      .map(function (row) {
        return row.product.handle;
      })
      .join(',');
  }

  function whenDepsReady() {
    return new Promise(function (resolve) {
      function ready() {
        return window.OleumRecommender && Array.isArray(window.OleumProductCatalog);
      }
      if (ready()) {
        resolve();
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (ready() || tries > 40) {
          clearInterval(timer);
          resolve();
        }
      }, 50);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('cart_http');
      return res.json();
    });
  }

  function fetchShopifyRecs(productId, limit) {
    var url =
      shopifyRoot() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      limit +
      '&intent=' +
      REC_INTENT;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function fetchAllShopifyRecs(cartItems) {
    var sorted = cartItems.slice().sort(function (a, b) {
      return (b.final_line_price || 0) - (a.final_line_price || 0);
    });
    var ids = [];
    sorted.forEach(function (item) {
      var id = String(item.product_id);
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    ids = ids.slice(0, 3);
    if (!ids.length) return Promise.resolve([]);

    return Promise.all(
      ids.map(function (id) {
        return fetchShopifyRecs(id, 10);
      })
    ).then(function (arrays) {
      var seen = {};
      var merged = [];
      arrays.forEach(function (arr) {
        (arr || []).forEach(function (p) {
          var key = String(p.id);
          if (seen[key]) return;
          seen[key] = true;
          merged.push(p);
        });
      });
      return merged;
    });
  }

  function collectMostCommon(products, field) {
    var counts = {};
    products.forEach(function (p) {
      var list = p[field];
      if (!list) return;
      var items = Array.isArray(list) ? list : [String(list)];
      items.forEach(function (val) {
        if (!val) return;
        var key = String(val);
        counts[key] = (counts[key] || 0) + 1;
      });
    });
    var best = null;
    var bestN = 0;
    Object.keys(counts).forEach(function (key) {
      if (counts[key] > bestN) {
        bestN = counts[key];
        best = key;
      }
    });
    return best;
  }

  function buildCartContext(cart, catalog) {
    var Engine = window.OleumProfileEngine;
    var base = Engine && Engine.loadUserContext ? Engine.loadUserContext() : null;
    var cartIds = {};
    var handles = [];

    (cart.items || []).forEach(function (item) {
      cartIds[String(item.product_id)] = true;
      if (item.handle) handles.push(item.handle);
    });

    var inCart = (catalog || []).filter(function (p) {
      return cartIds[String(p.id)];
    });

    var ctx = {
      intent: collectMostCommon(inCart, 'oleum_intents'),
      benefit: collectMostCommon(inCart, 'oleum_benefits'),
      aroma: collectMostCommon(inCart, 'oleum_aromas'),
      use_method: collectMostCommon(inCart, 'oleum_use_methods'),
      cart_product_ids: Object.keys(cartIds),
      cart_handles: handles
    };

    if (base && typeof base === 'object') {
      Object.keys(base).forEach(function (key) {
        if (ctx[key] == null || ctx[key] === '') ctx[key] = base[key];
      });
      ctx.profile = base.profile;
      ctx.role = base.role;
      ctx.experience_level = base.experience_level;
      ctx.route = base.route;
      ctx.collection_handle = base.collection_handle;
    }

    if (!ctx.benefit) ctx.benefit = 'bienestar_general';

    return ctx;
  }

  function shopifyImage(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

  function hybridPicks(catalog, ctx, shopifyProducts) {
    var Recommender = window.OleumRecommender;
    if (!Recommender) return [];

    var cartSet = {};
    (ctx.cart_product_ids || []).forEach(function (id) {
      cartSet[String(id)] = true;
    });

    var shopifyBoost = {};
    (shopifyProducts || []).forEach(function (p, index) {
      var boost = 48 - index * 5;
      if (p.handle) shopifyBoost[p.handle] = boost;
      shopifyBoost[String(p.id)] = boost;
    });

    var byId = {};
    (catalog || []).forEach(function (p) {
      if (p && p.id != null) byId[String(p.id)] = p;
    });

    var candidates = (catalog || []).filter(function (p) {
      return p && p.available !== false && !cartSet[String(p.id)];
    });

    (shopifyProducts || []).forEach(function (sp) {
      if (cartSet[String(sp.id)]) return;
      if (byId[String(sp.id)]) return;
      candidates.push({
        id: sp.id,
        handle: sp.handle,
        variant_id: sp.variants && sp.variants[0] ? sp.variants[0].id : null,
        title: sp.title,
        url: sp.url,
        image: shopifyImage(sp),
        price: sp.price,
        available: true,
        tags: sp.tags || [],
        oleum_intents: [],
        oleum_benefits: [],
        oleum_aromas: [],
        oleum_use_methods: []
      });
    });

    return candidates
      .map(function (p) {
        var oleum = Recommender.scoreProduct(p, ctx);
        var boost = shopifyBoost[p.handle] || shopifyBoost[String(p.id)] || 0;
        return { product: p, score: oleum.score + boost };
      })
      .filter(function (row) {
        return row.score > -500;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, LIMIT);
  }

  function isUpsellMode(root) {
    return root && root.getAttribute('data-oleum-cart-rec-mode') === 'upsell';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatPrice(cents) {
    if (typeof window.OleumFormatMoney === 'function') {
      return window.OleumFormatMoney(cents);
    }
    return '$' + Math.round(Number(cents || 0) / 100);
  }

  function enrichProduct(product) {
    if (product.variant_id) return Promise.resolve(product);
    return fetch('/products/' + encodeURIComponent(product.handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data) return product;
        var variant =
          (data.variants || []).find(function (v) {
            return v.available;
          }) || (data.variants && data.variants[0]);
        return {
          id: data.id,
          handle: data.handle,
          title: data.title,
          url: '/products/' + data.handle,
          image: product.image || data.featured_image || '',
          price: product.price || (variant && variant.price),
          variant_id: variant && variant.id,
          available: true
        };
      })
      .catch(function () {
        return product;
      });
  }

  function buildFastCard(product) {
    var wrap = document.createElement('div');
    wrap.className = 'oleum-cart-rec-card oleum-cart-upsell-card';
    wrap.setAttribute('data-oleum-cart-rec-card', '');
    wrap.setAttribute('data-product-handle', product.handle);

    var imgHtml = product.image
      ? '<a class="oleum-cart-upsell-card__media" href="' +
        escapeHtml(product.url) +
        '"><img src="' +
        escapeHtml(product.image) +
        '" alt="" loading="lazy" width="360" height="360" decoding="async"></a>'
      : '<a class="oleum-cart-upsell-card__media oleum-cart-upsell-card__media--empty" href="' +
        escapeHtml(product.url) +
        '"></a>';

    var addBtn = product.variant_id
      ? '<button type="button" class="oleum-cart-upsell-card__add" data-oleum-add-bag data-variant-id="' +
        product.variant_id +
        '"><span class="oleum-cart-upsell-card__add-icon" aria-hidden="true">+</span><span>Añadir</span></button>'
      : '';

    wrap.innerHTML =
      '<article class="oleum-cart-upsell-card__inner">' +
      imgHtml +
      '<div class="oleum-cart-upsell-card__body">' +
      '<h3 class="oleum-cart-upsell-card__title"><a href="' +
      escapeHtml(product.url) +
      '">' +
      escapeHtml(product.title) +
      '</a></h3>' +
      '<p class="oleum-cart-upsell-card__price">' +
      formatPrice(product.price) +
      '</p>' +
      addBtn +
      '</div></article>';

    return wrap;
  }

  function showSkeletons(grid, count) {
    if (!grid) return;
    grid.replaceChildren();
    grid.classList.add('oleum-cart-rec__grid--skeleton');
    for (var i = 0; i < (count || LIMIT); i++) {
      var sk = document.createElement('div');
      sk.className = 'oleum-cart-upsell-skeleton';
      grid.appendChild(sk);
    }
  }

  function wrapCard(node, handle) {
    if (!node) return null;
    var wrap = document.createElement('div');
    wrap.className = 'oleum-cart-rec-card';
    wrap.setAttribute('data-oleum-cart-rec-card', '');
    if (handle) wrap.setAttribute('data-product-handle', handle);
    wrap.appendChild(node);
    return wrap;
  }

  function fetchCard(handle) {
    if (cardCache[handle]) {
      return Promise.resolve(wrapCard(cardCache[handle].cloneNode(true), handle));
    }

    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('card_http');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card =
          doc.querySelector('[data-product-handle="' + handle + '"] .oleum-product-card') ||
          doc.querySelector('[data-product-handle="' + handle + '"]') ||
          doc.querySelector('.oleum-product-card');
        if (!card) return null;
        var inner =
          card.classList && card.classList.contains('oleum-product-card')
            ? card.closest('[data-product-handle]') || card
            : card;
        cardCache[handle] = inner.cloneNode(true);
        return wrapCard(cardCache[handle].cloneNode(true), handle);
      })
      .catch(function () {
        return null;
      });
  }

  function initCardBehaviors(container) {
    if (!container) return;
    if (typeof window.initOleumProductCardCtas === 'function') {
      window.initOleumProductCardCtas(container);
    }
    if (typeof window.initOleumCardBeneficiosIn === 'function') {
      window.initOleumCardBeneficiosIn(container);
    }
  }

  function hasRenderedPicks(root) {
    if (!root) return false;
    var grid = root.querySelector('[data-oleum-cart-rec-grid]');
    return !!(
      grid &&
      grid.children.length &&
      !grid.classList.contains('oleum-cart-rec__grid--skeleton')
    );
  }

  function renderFast(root, picks, cartFp) {
    var grid = root.querySelector('[data-oleum-cart-rec-grid]');
    var wrap = root.querySelector('[data-oleum-cart-rec-wrap]');
    if (!grid || !wrap) return Promise.resolve(false);

    var handlesFp = picksFingerprint(picks);
    var state = stateByRoot.get(root) || {};

    if (!picks.length) {
      grid.replaceChildren();
      grid.classList.remove('oleum-cart-rec__grid--skeleton');
      stateByRoot.set(root, { cartFp: cartFp || '', handles: '' });
      return Promise.resolve(false);
    }

    if (
      state.cartFp === cartFp &&
      state.handles === handlesFp &&
      hasRenderedPicks(root)
    ) {
      return Promise.resolve(true);
    }

    root.classList.add('oleum-cart-rec--loading');
    if (!hasRenderedPicks(root)) showSkeletons(grid);

    return Promise.all(
      picks.map(function (row) {
        return enrichProduct(row.product);
      })
    )
      .then(function (products) {
        var valid = products.filter(function (p) {
          return p && p.handle && p.variant_id;
        });
        if (!valid.length) {
          grid.replaceChildren();
          grid.classList.remove('oleum-cart-rec__grid--skeleton');
          return false;
        }
        var fragment = document.createDocumentFragment();
        valid.forEach(function (product) {
          fragment.appendChild(buildFastCard(product));
        });
        grid.classList.remove('oleum-cart-rec__grid--skeleton');
        grid.replaceChildren(fragment);
        initCardBehaviors(grid);
        stateByRoot.set(root, { cartFp: cartFp || '', handles: handlesFp });
        return true;
      })
      .finally(function () {
        root.classList.remove('oleum-cart-rec--loading');
      });
  }

  function render(root, picks, cartFp) {
    if (isUpsellMode(root)) {
      return renderFast(root, picks, cartFp);
    }

    var grid = root.querySelector('[data-oleum-cart-rec-grid]');
    var wrap = root.querySelector('[data-oleum-cart-rec-wrap]');
    if (!grid || !wrap) return Promise.resolve(false);

    var handlesFp = picksFingerprint(picks);
    var state = stateByRoot.get(root) || {};

    if (!picks.length) {
      wrap.hidden = true;
      root.hidden = true;
      if (grid.children.length) grid.replaceChildren();
      stateByRoot.set(root, { cartFp: cartFp || '', handles: '' });
      return Promise.resolve(false);
    }

    if (state.cartFp === cartFp && state.handles === handlesFp && grid.children.length) {
      root.hidden = false;
      wrap.hidden = false;
      return Promise.resolve(true);
    }

    root.hidden = false;
    wrap.hidden = false;
    root.classList.add('oleum-cart-rec--loading');

    return Promise.all(
      picks.map(function (row) {
        return fetchCard(row.product.handle);
      })
    )
      .then(function (cards) {
        var valid = cards.filter(Boolean);
        if (!valid.length) {
          wrap.hidden = true;
          root.hidden = true;
          return false;
        }
        var fragment = document.createDocumentFragment();
        valid.forEach(function (card) {
          fragment.appendChild(card);
        });
        grid.replaceChildren(fragment);
        initCardBehaviors(grid);
        stateByRoot.set(root, { cartFp: cartFp || '', handles: handlesFp });
        return true;
      })
      .finally(function () {
        root.classList.remove('oleum-cart-rec--loading');
      });
  }

  function refreshRoot(root, force) {
    if (!root || root.dataset.oleumCartRecBusy === 'true') return Promise.resolve(false);
    root.dataset.oleumCartRecBusy = 'true';

    return whenDepsReady()
      .then(function () {
        var catalog = window.OleumProductCatalog || [];
        return fetchCart().then(function (cart) {
          var cartFp = cartFingerprint(cart);
          var state = stateByRoot.get(root) || {};

          if (!cart.items || !cart.items.length) {
            root.hidden = true;
            var emptyWrap = root.querySelector('[data-oleum-cart-rec-wrap]');
            if (emptyWrap) emptyWrap.hidden = true;
            stateByRoot.set(root, { cartFp: '', handles: '' });
            return false;
          }

          if (!force && state.cartFp === cartFp && state.handles && hasRenderedPicks(root)) {
            return true;
          }

          return fetchAllShopifyRecs(cart.items).then(function (shopifyProds) {
            var ctx = buildCartContext(cart, catalog);
            var picks = hybridPicks(catalog, ctx, shopifyProds);
            if (!picks.length && shopifyProds.length) {
              var cartSet = {};
              (ctx.cart_product_ids || []).forEach(function (id) {
                cartSet[String(id)] = true;
              });
              picks = shopifyProds
                .filter(function (p) {
                  return !cartSet[String(p.id)];
                })
                .slice(0, LIMIT)
                .map(function (p) {
                  return {
                    product: {
                      id: p.id,
                      handle: p.handle,
                      title: p.title,
                      url: p.url,
                      available: true
                    },
                    score: 0
                  };
                });
            }
            return render(root, picks, cartFp);
          });
        });
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        root.dataset.oleumCartRecBusy = 'false';
      });
  }

  function refreshAll(force) {
    return Promise.all(
      Array.prototype.map.call(roots(), function (root) {
        return refreshRoot(root, force);
      })
    );
  }

  var preloadTimer = null;

  function schedulePrefetch() {
    if (preloadTimer) clearTimeout(preloadTimer);
    preloadTimer = setTimeout(function () {
      prefetchUpsell();
    }, 250);
  }

  function prefetchUpsell() {
    var root = upsellRecRoot();
    if (!root) return Promise.resolve();
    return whenDepsReady().then(function () {
      return refreshRoot(root, false);
    });
  }

  function bindCartPreload() {
    document.querySelectorAll('cart-drawer-component').forEach(function (drawer) {
      if (drawer.dataset.oleumRecPreload === 'true') return;
      drawer.dataset.oleumRecPreload = 'true';
      drawer.addEventListener('dialog:open', schedulePrefetch);
    });
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var root = upsellRecRoot();
      if (root && upsellDialog() && upsellDialog().open) {
        refreshRoot(root, true);
      }
    }, 400);
  }

  function closeUpsell() {
    var dialog = upsellDialog();
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    }
    dialog.classList.remove('is-open');
    upsellBusy = false;
  }

  function goToCheckout() {
    closeUpsell();
    submitCartCheckout();
  }

  function openUpsell() {
    if (upsellBusy) return;
    var dialog = upsellDialog();
    var root = upsellRecRoot();
    if (!dialog || !root) {
      goToCheckout();
      return;
    }

    upsellBusy = true;
    dialog.classList.add('is-open');
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (e) {
        /* ignore */
      }
    }

    var grid = root.querySelector('[data-oleum-cart-rec-grid]');
    var state = stateByRoot.get(root) || {};

    fetchCart()
      .then(function (cart) {
        var fp = cartFingerprint(cart);
        if (!cart.items || !cart.items.length) {
          goToCheckout();
          return;
        }

        if (state.cartFp === fp && hasRenderedPicks(root)) {
          upsellBusy = false;
          return;
        }

        if (!hasRenderedPicks(root)) {
          showSkeletons(grid);
        }

        return refreshRoot(root, true).then(function (hasPicks) {
          if (!hasPicks) {
            goToCheckout();
            return;
          }
          upsellBusy = false;
        });
      })
      .catch(function () {
        goToCheckout();
      });
  }

  function isCheckoutTrigger(el) {
    if (!el) return false;
    return el.matches('button[name="checkout"], input[name="checkout"]');
  }

  function isOleumCheckoutScope(el) {
    return !!el.closest(
      'cart-drawer-component, .oleum-cart-page, .cart-page, cart-items-component, .oleum-cart-sidebar'
    );
  }

  function bindCheckoutIntercept() {
    document.addEventListener(
      'click',
      function (event) {
        if (allowCheckoutSubmit) return;

        var btn = event.target.closest('button[name="checkout"], input[name="checkout"]');
        if (!btn || btn.disabled) return;
        if (!isOleumCheckoutScope(btn)) return;

        event.preventDefault();
        event.stopPropagation();
        openUpsell();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (allowCheckoutSubmit) {
          allowCheckoutSubmit = false;
          return;
        }

        var form = event.target;
        if (!form || !form.matches('form#cart-form, form[action*="/cart"]')) return;

        var submitter = event.submitter;
        if (!submitter || !isCheckoutTrigger(submitter)) return;
        if (!isOleumCheckoutScope(form)) return;

        event.preventDefault();
        event.stopPropagation();
        openUpsell();
      },
      true
    );
  }

  function bindUpsellUi() {
    var dialog = upsellDialog();
    if (!dialog || dialog.dataset.oleumUpsellBound === 'true') return;
    dialog.dataset.oleumUpsellBound = 'true';

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-oleum-cart-upsell-close]')) {
        event.preventDefault();
        closeUpsell();
      }
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeUpsell();
    });

    var continueBtn = dialog.querySelector('[data-oleum-cart-upsell-continue]');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        goToCheckout();
      });
    }
  }

  function init() {
    bindUpsellUi();
    bindCheckoutIntercept();
    bindCartPreload();
    document.addEventListener('cart:update', function () {
      schedulePrefetch();
      scheduleRefresh();
    });
    document.addEventListener('cart:refresh', function () {
      schedulePrefetch();
      scheduleRefresh();
    });
    document.addEventListener('shopify:section:load', function () {
      bindUpsellUi();
      bindCartPreload();
    });
    whenDepsReady().then(schedulePrefetch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.OleumCartRecommendations = {
    refresh: function () {
      return refreshAll(true);
    },
    refreshRoot: refreshRoot,
    openUpsell: openUpsell,
    goToCheckout: goToCheckout
  };
})();
